import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "svg",
    class: _normalizeClass(['svg-container', _ctx.color]),
    innerHTML: _ctx.image || _ctx.imageRef
  }, null, 10, _hoisted_1))
}